import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

/**
 * Counter-based loading tracker.
 * Counts in-flight HTTP requests so the spinner stays up while
 * ANY request is pending and hides only when ALL complete.
 */
@Injectable({ providedIn: 'root' })
export class LoadingService {

  private activeRequests = 0;
  private readonly loadingSubject = new BehaviorSubject<boolean>(false);

  /**
   * debounceTime(150) prevents flicker: requests that finish in
   * under 150ms never show a spinner at all, and rapid
   * back-to-back requests don't strobe it.
   */
  readonly loading$: Observable<boolean> = this.loadingSubject.pipe(
    debounceTime(150),
    distinctUntilChanged()
  );

  start(): void {
    this.activeRequests++;
    // console.log('[loading] start →', this.activeRequests);
    if (this.activeRequests === 1) this.loadingSubject.next(true);
  }
  
  stop(): void {
    this.activeRequests = Math.max(0, this.activeRequests - 1);
    // console.log('[loading] stop →', this.activeRequests);
    if (this.activeRequests === 0) this.loadingSubject.next(false);
  }
}